import Album from "./components/Album";

const App = () => {
  return (
    <div>
      <Album />
    </div>
  );
};

export default App;
